import Vue from 'vue';
import {Vue as _Vue} from "vue/types/vue";
import {VSelect} from "vuetify/lib";

const select = VSelect as unknown as typeof _Vue;

export default Vue.extend({
	name: 'AsiSelectSimple',
	extends: select,
	props: {
		hideDetails: {
			type: String,
			default: 'auto',
		},
		filled: {
			type: Boolean,
			default: true,
		},
		dense: {
			type: Boolean,
			default: true,
		},
		flat: {
			type: Boolean,
			default: true,
		},
		solo: {
			type: Boolean,
			default: true,
		},
	},
});
